import { useGetToursQuery } from '@energy-stacks/fleet/feature-tours-data';

export const useTours = () => {
  return useGetToursQuery(undefined);
};
